/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { ThemeSwitcherComponent } from './theme-switcher.component';

@NgModule({
    exports: [ ThemeSwitcherComponent ],
    imports: [ ThemeSwitcherComponent ]
})
export class ThemeSwitcherModule {}
